// extracted by mini-css-extract-plugin
export var slide = "slide-block-module--slide --f9c45";
export var slideItem = "slide-block-module--slideItem--3f48b";